var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73512 2.09996L2.94595 7.16913C2.76512 7.36163 2.59012 7.7408 2.55512 8.0033L2.33928 9.8933C2.26345 10.5758 2.75345 11.0425 3.43012 10.9258L5.30845 10.605C5.57095 10.5583 5.93845 10.3658 6.11928 10.1675L10.9085 5.0983C11.7368 4.2233 12.1101 3.2258 10.821 2.00663C9.53762 0.79913 8.56345 1.22496 7.73512 2.09996Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93579 2.9458C7.18662 4.5558 8.49329 5.78663 10.115 5.94997",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.8333H12.25",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEntry);
export default __webpack_public_path__ + "static/media/editEntry.caaa76f576c0319534e5ddd82aea77b2.svg";
export { ForwardRef as ReactComponent };